import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabSwitchDetector from './TabSwitchDetector';

const FullscreenDetector = () => {
  const [, setIsFullscreen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [cancelCount, setCancelCount] = useState(0);
  const hasEnteredFullscreenRef = useRef(false);
  const navigate = useNavigate();

  const handleFullscreenChange = () => {
    const fullscreen = !!document.fullscreenElement;
    setIsFullscreen(fullscreen);

    if (fullscreen) {
      hasEnteredFullscreenRef.current = true;
      setShowDialog(false);
      return;
    }

    // The exam page can render briefly before the browser has entered
    // fullscreen. That initial state is not an exit and must not trigger the
    // exit confirmation dialog.
    setShowDialog(hasEnteredFullscreenRef.current);
  };

  const requestFullscreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) { // Firefox
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
      document.documentElement.msRequestFullscreen();
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);
    handleFullscreenChange();

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  const handleCancel = () => {
    setCancelCount(prevCount => prevCount + 1);

    if (cancelCount >= 4) { // Check if cancel count is 4 (5 total)
      alert('Something went wrong,redirecting you back');
      navigate('/sign-in');
    } else {
      setShowDialog(false);
    }
    setShowDialog(true);
  };

  return (
    <div id="fullscreen-exit-container">
      <TabSwitchDetector />

      {showDialog && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          id="fullscreen-exit-overlay"
        >
          <div
            className="bg-white rounded-lg p-6 shadow-lg w-11/12 md:w-1/3"
            id="fullscreen-exit-dialog"
          >
            <h2 className="text-lg font-semibold mb-4" id="fullscreen-exit-title">
              Exit Fullscreen
            </h2>

            <p className="mb-4" id="fullscreen-exit-message">
              Are you sure to exit exam?
            </p>

            <div className="flex justify-end" id="fullscreen-exit-actions">
              <button
                id="fullscreen-exit-no-btn"
                onClick={requestFullscreen}
                className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition"
              >
                No
              </button>
              <button
                id="fullscreen-exit-yes-btn"
                onClick={handleCancel}
                className="ml-2 bg-gray-300 py-2 px-4 rounded hover:bg-gray-400 transition"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FullscreenDetector;
